let domLoaded = false;
let igReady = false;

function handleExperiments() {
  if (!domLoaded || !igReady) return;
  // Test: V_PRO_SITE_09 | Sitewide - Price Anchor Test
  const vProSite09 = window.igData?.user.getTestGroup(
    "907388a4-231f-448b-83d5-a8d13189e3f4"
  );
  if (vProSite09?.name === "Var A") {
    document.body.classList.add("c-vProSite09VarA");
  } else {
    document.body.classList.add("c-vProSite09Control");
  }

  // Test: V_PRO_MIX_16 | Black Friday Gift-Ladder Bundle System
  const vProMix16 = window.igData?.user.getTestGroup(
    "40905d62-9a21-445e-9e5e-f9277803c9e2"
  );
  if (vProMix16?.id === "800f6cdc-1a13-4f32-b765-1d340ce0ac53") {
    document.body.classList.add("c-vProMix16VarA");
  } else if (vProMix16?.id === "ed192677-325f-48ab-8b24-8e5e68fd1138") {
    document.body.classList.add("c-vProMix16VarB");
  }

  // Test: V_PRO_PROD-CARD_15 | Quick-View Optimization - CLP
  const vProProdCard15 = window.igData?.user.getTestGroup(
    "1c801af6-e98a-431c-8e54-0e90edc119a3"
  );
  if (vProProdCard15?.id === "7ec4ad6c-fbcd-41e3-92c1-626d1c6de455") {
    document.body.classList.add("c-vProProdCard15VarA");
  } else if (vProProdCard15?.id === "71f6a2a0-90b0-40bd-b648-3264c67f2025") {
    document.body.classList.add("c-vProProdCard15VarB");
  }
}

document.addEventListener("DOMContentLoaded", () => {
  domLoaded = true;
  handleExperiments();
});

window.addEventListener("ig:ready", () => {
  igReady = true;
  handleExperiments();
});
